
import algoliasearch from 'algoliasearch';
export const algoliaClient = algoliasearch("X9G4EYXZG2", "15984b76eabf34113d9384dc4fd2f642");
export const contactPhone = "+971565627618";
export const contactWhatsAppUrl = 'http://api.whatsapp.com/send?phone='+contactPhone;
export const contactSnapChatUrl = 'https://www.snapchat.com/add/\whizz_around';
export const contactInstagramUrl = 'https://www.instagram.com/whizzaround';
export const contactFacebookUrl = 'https://www.facebook.com/Whizz-Around-574206072784848';
export const getEmirates = (language) =>[
    {
        label: language === "ar" ? "عجمان" : "Ajman",
        value: "Ajman",
    },
    {
        label: language === "ar" ? "الشارقة" : "Sharjah",
        value: "Sharjah",
    },
    {
        label: language === "ar" ? "ابو ظبي" : "Abu Dhabi",
        value: "AbuDhabi",
    },
    {
        label: language === "ar" ? "دبي" : "Dubai",
        value: "Dubai",
    },
    {
        label: language === "ar" ? "ام القيوين" : "Umm Al Quwain",
        value: "UmmAlQuwain",
    },
    {
        label: language === "ar" ? "راس الخيمة" : "Ras Al Khaimah",
        value: "RasAlKhaimah",
    },
    {
        label: language === "ar" ? "الفجيرة" : "Fujairah",
        value: "Fujairah",
    },
];

export const getRegion = (language) =>[
    {
        label: language === "ar" ? "الروضة" : "Al Rowdha",
        emirate: "Ajman",
        value: "AlRowdha",
    },
    {
        label: language === "ar" ? "السوان" : "Al Sawan",
        emirate: "Ajman",
        value: "AlSawan",
    },
    {
        label: language === "ar" ? "الصناعية القديمة" : "Old Industrial Area",
        emirate: "Ajman",
        value: "OldIndustrialArea",
    },
    {
        label: language === "ar" ? "الصناعية الجديدة" : "New Industrial Area",
        emirate: "Ajman",
        value: "NewIndustrialArea",
    },
    {
        label: language === "ar" ? "الظهران" : "Al Dhran",
        emirate: "Ajman",
        value: "AlDhran",
    },

    {
        label: language === "ar" ? "الحليو" : "Al Helio",
        emirate: "Ajman",
        value: "AlHelio",
    },
    {
        label: language === "ar" ? "البستان" : "Al Bustan",
        emirate: "Ajman",
        value: "AlBustan",
    },
    {
        label: language === "ar" ? "الرميلة" : "Al Rumailah",
        emirate: "Ajman",
        value: "AlRumailah",
    },
    {
        label: language === "ar" ? "النعيمية" : "Al Naemiyah",
        emirate: "Ajman",
        value: "AlNaemiyah",
    },
    {
        label: language === "ar" ? "الزهرة" : "Al Zahra",
        emirate: "Ajman",
        value: "AlZahra",
    },
    {
        label: language === "ar" ? "الراشدية" : "Al Rashidiya",
        emirate: "Ajman",
        value: "AlRashidiya",
    },
    {
        label: language === "ar" ? "المويهات" : "Al Muwayhat",
        emirate: "Ajman",
        value: "AlMuwayhat",
    },
    {
        label: language === "ar" ? "الحميدية" : "Al Hamidiya",
        emirate: "Ajman",
        value: "AlHamidiya",
    },

    {
        label: language === "ar" ? "الجرف" : "Al Jurf",
        emirate: "Ajman",
        value: "AlJurf",
    },
    {
        label: language === "ar" ? "مشيرف" : "Al Mushairef",
        emirate: "Ajman",
        value: "AlMushairef",
    },
    {
        label:  language === "ar" ? "الحيرة" : "Al Heera",
        emirate: "Sharjah",
        value: "AlHeera",
    },
    {
        label:  language === "ar" ? "القصبة": "Al Qasba",
        emirate: "Sharjah",
        value: "AlQasba",
    },
    {
        label:  language === "ar" ? "الحمارية": "Al Hamriya",
        emirate: "Sharjah",
        value: "AlHamriya",
    },
    {
        label:  language === "ar" ? "الجزيرة": "Al Jazirah",
        emirate: "Sharjah",
        value: "AlJazirah",
    },
    {
        label:  language === "ar" ? "الخان": "Al Khan",
        emirate: "Sharjah",
        value: "AlKhan",
    },
    {
        label:  language === "ar" ? "العين": "Al `Ayn",
        emirate: "AbuDhabi",
        value: "AlAyn",
    },
];
export const getGenders = (t) =>[
    {
        label: t('general.male'),
        value: "Male"
    },
    {
        label: t('general.female'),
        value: t('Female')
    }
]

export const AsyncStorageKeys = {
    Cart: '@Cart',
    Compare:"@Compare-selected-product",
    CompareList:"@Compare-list",
}